import styled, { keyframes } from 'styled-components';

/* /!\ If you change something here, change it in the public/index.html too */

const LoaderAnimation = keyframes`
  to {
    stroke-dashoffset: 0px;
  }
`;

export const LoaderSVG = styled.svg`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  max-width: 25em;
  fill: none;
  stroke: #047474;
  stroke-linecap: round;
  stroke-width: 8%;
`;
LoaderSVG.displayName = 'LoaderSVG';

export const LoaderUse = styled('use')`
  animation: ${LoaderAnimation} 2s linear infinite;
`;
LoaderUse.displayName = 'LoaderUse';
